import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import styles from './FeatureDashboard.module.css';
import img from '../assets/2.jpg';

const FeatureDashboard = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });
  
  const yImage = useTransform(scrollYProgress, [0, 1], ['-20%', '20%']);
  const scaleImage = useTransform(scrollYProgress, [0, 1], [1.1, 1]);

  const containerVars = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { staggerChildren: 0.12 }
    }
  };

  const itemVars = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } }
  };

  return (
    <section ref={ref} className={styles.section}>
      <motion.div 
        className={styles.bg}
        style={{ 
          backgroundImage: `url(${img})`,
          y: yImage,
          scale: scaleImage
        }}
      />
      <div className={styles.overlay} />

      <div className={styles.content}>
        <motion.div 
          className={styles.textContent}
          variants={containerVars}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <motion.div variants={itemVars} className={styles.eyebrow}>
            UNDERSTAND
          </motion.div>
          <motion.h2 variants={itemVars} className={styles.title}>
            Your noise, over time.
          </motion.h2>
          <motion.p variants={itemVars} className={styles.body}>
            The dashboard shows your weekly noise exposure as a bar chart, categorized by day. Tap any bar to drill into the measurements from that date — times, locations, exact decibels.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default FeatureDashboard;
